
import {Breadcrumb} from 'react-admin-base-nazox';

import { Route, Routes } from "react-router-dom";
import { useUser } from "../../Components/UserProvider";
import CategoryEntity from "./CategoryEntity";
import ContentDataTable from "../../Components/ContentDataTable";

export default function Categories() {
    const user = useUser();

    return <Routes>
        <Route path=":id/edit" element={<CategoryEntity />} />
        <Route path="create" element={<CategoryEntity />} />
        <Route path="*" element={
        <Breadcrumb
            title="Category"
            data={
                [
                    {
                        href: '/category',
                        name: 'Categories'
                    }
                ]
            }
        >
            <ContentDataTable url="/category" />
        </Breadcrumb>
        } />
    </Routes>;
}
